/**
 * editing redux constants
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const LOAD_OBJECT                    = 'LOAD_OBJECT';
export const SAVE_OBJECT                    = 'SAVE_OBJECT';
export const SWITCH_OBJECT                  = 'SWITCH_OBJECT';
export const CREATE_NEW_OBJECT              = 'CREATE_NEW_OBJECT';
export const CREATE_NEW_REFERENCE           = 'CREATE_NEW_REFERENCE';
export const CREATE_NEW_ELEMENT             = 'CREATE_NEW_ELEMENT';
export const UPDATE_WHOLE_OBJECT            = 'UPDATE_WHOLE_OBJECT';
export const UPDATE_OBJECT_VALUE            = 'UPDATE_OBJECT_VALUE';
export const UPDATE_OBJECT_MAP              = 'UPDATE_OBJECT_MAP';
export const POP_EDIT_STACK                 = 'POP_EDIT_STACK';
export const ASSIGN_ELEMENT                 = 'ASSIGN_ELEMENT';
export const PUSH_ELEMENT                   = 'PUSH_ELEMENT';
export const REMOVE_FIELD_ELEMENT           = 'REMOVE_FIELD_ELEMENT';
export const MOVE_FIELD_ELEMENT             = 'MOVE_FIELD_ELEMENT';
export const DELETE_OBJECT_TAG              = 'DELETE_OBJECT_TAG';
export const ADD_OBJECT_TAG                 = 'ADD_OBJECT_TAG';
export const LOAD_ALL_TAGS                  = 'LOAD_ALL_TAGS';
export const CHANGE_TAB                     = 'CHANGE_TAB';
export const SET_EDIT_FLAG                  = 'SET_EDIT_FLAG';
export const FETCH_REFERENCED_OBJECTS       = 'FETCH_REFERENCED_OBJECTS';
export const FETCH_REFERENCABLE_OBJECTS     = 'FETCH_REFERENCABLE_OBJECTS';
export const EXECUTE_OBJECT_COMMAND         = 'EXECUTE_OBJECT_COMMAND';
